module.exports = __webpack_public_path__ + "static/media/suggestion dictionary sample data.e85904bc.csv";